import clsx from 'clsx';
import EditableCell from './EditableCell';
import { TableError } from '../../../types/common';

interface Column {
  accessor: string;
  center?: boolean;
  editable?: boolean;
  [key: string]: any;
}

interface SubRowProps {
  parentId: string;
  parentRow?: Record<string, any>;
  row: Record<string, any>;
  index: number;
  columns: any[];
  editingRows: Set<string>;
  onEdit: (rowIndex: number, columnId: string, value: any, defaultValueName?: string) => void;
  onRowEdit: (rowId: string) => void;
  errors?: TableError[];
}

const SubRow: React.FC<SubRowProps> = ({
  parentId,
  parentRow,
  row,
  index,
  columns,
  editingRows,
  onEdit,
  onRowEdit,
  errors,
}) => {
  const subRowId = `${parentId}.${index}`;
  return (
    <tr className={clsx('child-row', editingRows.has(subRowId) && 'editing')}>
      <td className='indent-cell'></td>
      {columns.map((column, index) => (
        <EditableCell
          key={`${column.accessor}-${index}`}
          cell={{
            value: row?.[column.accessor],
            column,
            getCellProps: () => ({
              style: {
                width: column.width,
                textAlign: column.center ? 'center' : 'left',
                cursor: column.editable ? 'pointer' : 'default',
              },
              role: 'cell',
              'aria-label': `${column.Header || column.accessor}: ${row[column.accessor]}`,
              onDoubleClick: column.editable ? () => onRowEdit(subRowId) : undefined,
            }),
          }}
          value={row?.[column.accessor]}
          row={{
            original: row,
            index: subRowId as any,
          }}
          column={column as any}
          isEditable={column.editable as any}
          isRowEditable={editingRows.has(subRowId)}
          onEdit={onEdit}
          onRowEdit={onRowEdit}
          errors={errors?.find((error) => error.sNo == parentId)?.subRow as any}
        />
      ))}
      {Array(parentRow?.cells.length - columns.length - 1)
        .fill(null)
        .map((v, i) => (
          <td key={`empty-${i}`} className='indent-cell'></td>
        ))}
    </tr>
  );
};

export default SubRow;
